export default __webpack_public_path__ + "static/media/bonecos.e4e78f25.png";